import { push } from "connected-react-router";
import normalize from "json-api-normalizer";
import build from "redux-object";
import get from "lodash/get";

import { ASYNC_START, SET_CURRENT_USER, ASYNC_END, REDIRECT, SET_CURRENT_TENANT, STORE_TENANTS } from "./types";
import AuthService from "../services/auth.service";
import TenantService from "../services/tenant.service";
import config from "../config";

export const appLoaded = () => async dispatch => {
  dispatch({ type: ASYNC_START });

  try {
    const currentUserResult = await AuthService.getCurrentUser({
      params: { include: "tenant" }
    });

    dispatch({ type: ASYNC_END });

    const normalizedState = normalize(currentUserResult.data);
    const currentUser = build(normalizedState, "users", null, {
      ignoreLinks: true
    })[0];

    config.PUSHER_DISABLED = get(currentUser, "meta.pusherDisabled");

    if (currentUser.admin === true) {
      dispatch({ type: ASYNC_START });
      const tenantsResult = await TenantService.getAll();
      dispatch({ type: ASYNC_END });

      normalizedState.tenants = normalize(tenantsResult.data).tenants;

      const currentTenant = handleCurrentTenant(normalizedState);

      TenantService.store(currentTenant.slug);

      dispatchAppLoad(dispatch, currentUser, currentTenant, normalizedState.tenants);
    } else {
      TenantService.store(currentUser.tenant.slug);

      dispatchAppLoad(dispatch, currentUser, currentUser.tenant, normalizedState.tenants);
    }
  } catch (error) {
    dispatch({ type: ASYNC_END });
    dispatch({ type: SET_CURRENT_USER, error: true });
  }
};
export const switchTenant = tenant => async dispatch => {
  TenantService.store(tenant.slug);

  dispatch({ type: SET_CURRENT_TENANT, currentTenant: tenant });

  dispatch(push("/customer_groups"));
};

const handleCurrentTenant = normalizedState => {
  const localStorageTenantSlug = TenantService.get();

  return localStorageTenantSlug
    ? build(normalizedState, "tenants", localStorageTenantSlug, { ignoreLinks: true })
    : build(normalizedState, "tenants", null, { ignoreLinks: true })[0];
};

const dispatchAppLoad = (dispatch, currentUser, currentTenant, tenants) => {
  dispatch({ type: SET_CURRENT_USER, currentUser });
  dispatch({ type: STORE_TENANTS, tenants });
  dispatch({ type: SET_CURRENT_TENANT, currentTenant });
};

export const redirect = path => dispatch => {
  dispatch({ type: REDIRECT });
  dispatch(push(path));
};
